import { SOURCE_LOCALE_ID } from "@bitcart/core/i18n";
import { useCallback, useMemo } from "react";
import { usePageContext } from "vike-react/usePageContext";
import { getDestinationTypeAwareLinkProps, isInternalHref, scrollTo } from "@bitcart/core/navigation";
import { jsx, jsxs } from "react/jsx-runtime";
import { isLmbClick } from "@bitcart/core/utils";
// src/navigation/components/link.tsx
const Link = ({ a11yHint, disabled: isDisabled = false, originAware: isOriginAware = true, href, locale, onClick, children, ...props }) => {
	const { localeId: pageLocaleId } = usePageContext();
	const localizedHref = useMemo(() => {
		const localeId = locale ?? pageLocaleId;
		if (href !== void 0 && isInternalHref(href) && localeId !== SOURCE_LOCALE_ID) return `/${localeId}` + (href === "/" ? "" : href);
		else return href;
	}, [
		href,
		locale,
		pageLocaleId
	]);
	const anchorElementProps = {
		...getDestinationTypeAwareLinkProps({
			href: localizedHref,
			isOriginAware
		}),
		...props
	};
	const handleClick = useCallback((event) => {
		if (!isDisabled) {
			onClick?.(event);
			if (isLmbClick(event) && localizedHref !== void 0 && isInternalHref(localizedHref)) {
				const target = new URL(localizedHref, window.location.href);
				if (target.pathname === window.location.pathname) {
					event.preventDefault();
					event.stopPropagation();
					if (target.href !== window.location.href) {
						window.history.pushState({}, "", localizedHref);
						window.dispatchEvent(new HashChangeEvent("hashchange"));
					}
					const targetHash = target.hash.slice(1);
					window.setTimeout(() => {
						if (targetHash) scrollTo({ selector: `#${targetHash}` });
						else scrollTo({ direction: "top" });
					}, 0);
				}
			}
		}
	}, [
		isDisabled,
		localizedHref,
		onClick
	]);
	return /* @__PURE__ */ jsxs("a", {
		href: localizedHref,
		onClick: handleClick,
		...anchorElementProps,
		children: [children, a11yHint && /* @__PURE__ */ jsx("span", {
			className: "sr-only",
			children: a11yHint
		})]
	});
};
export { Link };

//# sourceMappingURL=link.js.map